import { MarketingPageContact } from "@/src/components/pages/marketing/MarketingPageContact"
import { MarketingPageLinks } from "@/src/components/pages/marketing/MarketingPageLinks"
import { MarketingPagePhotos } from "@/src/components/pages/marketing/MarketingPagePhotos"
import { NewsItem } from "@/src/components/pages/marketing/news/NewsItem"
import { newsItems } from "@/src/components/pages/marketing/news/newsItems.const"

export function PageMarketing() {
  return (
    <>
      <section className="w-full px-6 pb-16 md:px-8">
        <div className="max-w-2xl">
          <h1 className="mt-20 text-4xl font-semibold tracking-tight text-gray-800 sm:text-5xl">
            Trassenscout findet Wege
          </h1>
          <div className="prose mt-6">
            <p>
              Der Trassenscout unterstützt Kommunen und Regionalverbände bei der Erstellung von
              Machbarkeitsstudien und Vorplanungen für Radschnellverbindungen und anderer
              liniengebundener Bauwerken.
            </p>
            <p>
              Der Trassenscout bindet Akteure über kommunale Grenzen hinaus konstruktiv in
              Abstimmungsprozesse ein. Dabei wollen Träger öffentlicher Belange, Umwelt- und
              Bauernverbände sowie interne wie externe Stakeholder unterschiedlich mitgenommen
              werden.
            </p>
            <p>
              Für die Durchführung öffentlicher Beteiligungen bietet der Trassenscout einfach
              verständliche und konfigurierbare Formulare zur Abbildung von Beteiligungsverfahrens
              an, die Sie anschließend komfortabel auswerten können.
            </p>
            <p>
              Gleichzeitig müssen Sie mit Ihrem Projektteam auf einer aktuellen Datenbasis die
              nächsten Schritte planen und sich koordinieren können. Bei diesen Aufgaben unterstützt
              Sie der Trassenscout.
            </p>
          </div>
        </div>
      </section>

      <MarketingPagePhotos />

      <section className="mt-16 w-full px-6 pb-16 md:px-8">
        <div className="mx-auto grid max-w-xl grid-cols-1 gap-y-12 lg:max-w-none lg:grid-cols-2 lg:gap-y-20">
          <div className="flex flex-col gap-16">
            {newsItems.map((newsItem) => (
              <NewsItem key={newsItem.slug} article={newsItem} />
            ))}
          </div>
          <div className="space-y-10 lg:pl-16 xl:pl-24">
            <MarketingPageContact />
            <MarketingPageLinks />
          </div>
        </div>
      </section>
    </>
  )
}
